import React from 'react';
import AdminLayout from '@/components/AdminLayout';
import { HelpFaq } from '@/components/HelpFaq';
import { staffHelp } from '@/data/helpContent';

export default function AdminHelp() {
  return (
    <AdminLayout title="Staff Guide">
      <div className="max-w-4xl" data-testid="admin-help-page">
        <p className="text-[#78716C] mb-8">How to run day-to-day operations in AcquaCana.</p>
        <HelpFaq sections={staffHelp} prefix="admin-help" />
      </div>
    </AdminLayout>
  );
}
